module.exports = {"domains":["vitalsource.com","vitalsource.co.uk","vitalbook.com"],"protocols":["http:","https:","vbk:"]}


//////////////////
// WEBPACK FOOTER
// ./src/config/base/whitelist.json
// module id = 646
// module chunks = 162